import { DamageLocation } from "./damage";

export const damageVerbiage = [
  {
    orderNumber: 1,
    label: "Front center area",
    description: "Front center area",
    cardDescription: "Middle of the front of the vehicle.",
    damageLocation: DamageLocation.FRONT,
    showImage: true,
  },
  {
    orderNumber: 5,
    label: "Back center area",
    description: "Back center area",
    cardDescription: "Middle of the back of the vehicle.",
    damageLocation: DamageLocation.BACK,
    showImage: true,
  },
  {
    orderNumber: 2,
    label: "Right front area",
    description: "Right front area",
    cardDescription: "Front right side of the vehicle.",
    damageLocation: DamageLocation.RIGHT_SIDE_FRONT,
    showImage: true,
  },
  {
    orderNumber: 3,
    label: "Right center area",
    description: "Right center area",
    cardDescription: "Middle of the right side of the vehicle.",
    damageLocation: DamageLocation.RIGHT_SIDE_MIDDLE,
    showImage: true,
  },
  {
    orderNumber: 4,
    label: "Right rear area",
    description: "Right rear area",
    cardDescription: "Rear right side of the vehicle.",
    damageLocation: DamageLocation.RIGHT_SIDE_REAR,
    showImage: true,
  },
  {
    orderNumber: 6,
    label: "Left front area",
    description: "Left front area",
    cardDescription: "Front left side of the vehicle.",
    damageLocation: DamageLocation.LEFT_SIDE_FRONT,
    showImage: true,
  },
  {
    orderNumber: 7,
    label: "Left center area",
    description: "Left center area",
    cardDescription: "Middle of the left side of the vehicle.",
    damageLocation: DamageLocation.LEFT_SIDE_MIDDLE,
    showImage: true,
  },
  {
    orderNumber: 8,
    label: "Left rear area",
    description: "Left rear area",
    cardDescription: "Rear left side of the vehicle.",
    damageLocation: DamageLocation.LEFT_SIDE_REAR,
    showImage: true,
  },
  {
    orderNumber: 9,
    label: "Top of passenger area",
    description: "Top",
    cardDescription: "Roof of the vehicle, over passenger area.",
    damageLocation: DamageLocation.TOP,
    showImage: true,
  },
  {
    orderNumber: 11,
    label: "Undercarriage",
    description: "Undercarriage",
    damageLocation: DamageLocation.UNDERCARRIAGE,
    showImage: false,
  },
  {
    orderNumber: 10,
    label: "Load/trailer attachment",
    description: "Load/trailer attachment",
    damageLocation: DamageLocation.ATTACHMENT,
    showImage: false,
  },
];

export interface InitialPointOfImpact {
  id: number;
  description: string;

  getDamageLocationEnum(): DamageLocation;
  getDamageVerbiage(): any;
}

export class InitialPointOfImpact implements InitialPointOfImpact {
  id: number;
  description: string;

  constructor(id: number, description: string) {
    this.id = id;
    this.description = description;
  }

  getDamageLocationEnum(): DamageLocation {
    const enumValues = Object.values(DamageLocation);
    return enumValues.find(
      (enumValue) => enumValue === this.description
    ) as DamageLocation;
  }

  getDamageVerbiage(): any {
    return damageVerbiage.find(
      (damage) => damage.damageLocation === this.getDamageLocationEnum()
    );
  }
}
